/**
 * Contratos zod del endpoint Usuarios.
 */

import { z } from 'zod';
import { ROLES, PROVEEDORES_AUTH, normalizarRol } from '@/domain/types';

export const RolSchema = z.preprocess(normalizarRol, z.enum(ROLES));
export const ProveedorAuthSchema = z.enum(PROVEEDORES_AUTH);

export const UsuarioSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  nombre: z.string().min(1),
  iniciales: z.string().min(1).max(3),
  rol: RolSchema,
  email: z.string().email().optional(),
  ubicacionId: z.string().min(1),
  ubicacionDefaultId: z.string().optional(),
  ubicacionesIds: z.array(z.string()).optional(),
  /** PIN de firma electrónica — 4 a 6 dígitos numéricos. Preparado (paquete AC),
   *  todavía no usado por el FirmaElectronicaModal. Ver domain/types.ts para
   *  el racional regulatorio (Part 11 §11.200 "two distinct components"). */
  pin: z.string().regex(/^\d{4,6}$/, 'PIN debe ser 4 a 6 dígitos').optional(),
  proveedorAuth: ProveedorAuthSchema.optional(),
  avatarUrl: z.string().url().optional(),
});

export const GetUsuariosResponse = z.array(UsuarioSchema);

export type Usuario = z.infer<typeof UsuarioSchema>;
